import { BrowserRouter as Router, Routes, Route ,Navigate } from "react-router-dom";
import Layout from "../components/layout";
import ComingSoon from "../pages/comingSoon";
import { comingSoonActive } from "../constants";
import RequireAuth from "./RequireAuth";
import Login from "../pages/login";
import Home from "../pages/home";
import Referral from "../pages/referral"; 
import Cards from "../pages/cards";
import Game from "../pages/game";
import Pvp from "../pages/pvp";
import Leaderboard from "../pages/inlinePages/leaderboard";
import Inventory from "../pages/inlinePages/inventory";
// import Transactions from "../pages/inlinePages/transactions";
import Battle from "../pages/inlinePages/battle";
import PreviewPack from "../pages/inlinePages/previewPack";
// import Ballcano from "../pages/inlinePages/ballcano";
// import Roulette from "../pages/inlinePages/roulette";
// import JoinRoulette from "../pages/inlinePages/joinRoulette";
import BeforeBattle from "../pages/inlinePages/beforeBattle";
import OpenPack from "../pages/inlinePages/packOpen";
import OpenedPack from "../pages/inlinePages/openedPack";
import Wallet from "../pages/wallet";
import Market from "../pages/inlinePages/market";
import Orders from "../pages/inlinePages/orders";

const AppRouter = () => {

  if (comingSoonActive) {
    return (
      <Router>
        <Layout>
          <Routes>
            <Route path="/" element={<ComingSoon />} />
            <Route
                path="*"
                element={<Navigate to="/" replace />}
            />
          </Routes>
        </Layout>
      </Router>
    );
  }
return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<RequireAuth><Home /></RequireAuth>} />
          <Route path="/referral" element={<RequireAuth><Referral /></RequireAuth>} />
          <Route path="/cards" element={<RequireAuth><Cards /></RequireAuth>} />
          <Route path="/game" element={<RequireAuth><Game /></RequireAuth>} />
          <Route path="/pvp" element={<RequireAuth><Pvp /></RequireAuth>} />
          <Route path="/inventory" element={<RequireAuth><Inventory /></RequireAuth>} />
          <Route path="/orders" element={<RequireAuth><Orders /></RequireAuth>} />
          <Route path="/battle" element={<RequireAuth><Battle /></RequireAuth>} />
          <Route path="/openPack" element={<RequireAuth><OpenPack /></RequireAuth>} />
          <Route path="/openedPack" element={<RequireAuth><OpenedPack /></RequireAuth>} />
          <Route path="/previewPack" element={<RequireAuth><PreviewPack /></RequireAuth>} />
          <Route path="/leaderboard" element={<RequireAuth><Leaderboard /></RequireAuth>} />
          {/* <Route path="/ballcano" element={<RequireAuth><Ballcano /></RequireAuth>} />
          <Route path="/roulette" element={<RequireAuth><Roulette /></RequireAuth>} />
          <Route path="/roulette/join" element={<RequireAuth><JoinRoulette /></RequireAuth>} /> */}
          <Route path="/beforeBattle" element={<RequireAuth><BeforeBattle /></RequireAuth>} />
          <Route path="/market" element={<RequireAuth><Market /></RequireAuth>} />
          <Route path="/wallet" element={<RequireAuth><Wallet /></RequireAuth>} />
          <Route
              path="*"
              element={<Navigate to="/" replace />}
          />
        </Routes>
      </Layout>
    </Router>
)

};

export default AppRouter;